import * as React from 'react';
import { useEffect } from 'react';
import _ from 'lodash';
import { Paper, makeStyles, Grid, TextField, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { loadFlights, moveFlight, loadFlight, changeChartKey } from '../../store/flights'
import { loadDepartures } from "../../store/departures";
import axios from "axios"


let windowWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: windowWidth >= 500 ? '40%' : '90%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
  },
  sendingPaper: {
    position: 'absolute',
    width: '12%',
    height: '10%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%',
    padding: '2px 4px 2px 4px'
  },
}));

  
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

const changeDateToLocal = (date) => {
  // NOTE // local date
  let localDate = new Date(date)

  // NOTE // formatting
  return new Date(localDate).toString().slice(4, 21)
}

const pad = (num) => {
  return Number(num) < 10 ? '0' + num : num
}

const formatDateForInput = (date) => {
  let localDate = changeDateToLocal(date)
  let year = localDate.slice(7, 11)
  let month = pad(months.findIndex(m => localDate.slice(0, 3) == m) + 1)
  let day = localDate.slice(4, 6)
  let hour = localDate.slice(12, 14)
  let minutes = localDate.slice(15, 17)
  let formattedDate = `${year}-${month}-${day}T${hour}:${minutes}`
  return formattedDate
}

const formatDateForMoveFlight = (date, offset) => {
  let newDate

  // NOTE // for new local date
  if (offset) {
    let utcTime = new Date(date).getTime()
    let localOffset = new Date().getTimezoneOffset()
    // NOTE // new Date() provided with milliseconds returns an adjusted local date, so to get the airports local date-time we adjust for both the offset and the local offset.
    let adjustedDate = new Date(utcTime + (offset * 60000) + (localOffset * 60000)).toString()
    let time = adjustedDate.slice(16, 24)
    let day = adjustedDate.slice(8, 10)
    let month = pad(months.findIndex(m => adjustedDate.slice(4, 7) == m) + 1)
    let year = adjustedDate.slice(11, 15)
    newDate = `${year}-${month}-${day} ${time}`
  }
  // for new utc date
  else {
    let isoDate = new Date(date).toISOString()
    // 2021-06-29T12:00:00.000Z
    let d1 = isoDate.slice(0, 10)
    let d2 = isoDate.slice(11, 19)
    newDate = d1 + ' ' + d2 + 'Z'
  }
  return newDate
}

export const MoveFlightModal = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const dep = props.dep
  const depInfo = dep.flightStatusLeg
  const flights = useSelector(state => state.entities.flights.list)
  const flight = flights.find(f => f.flightNumber == dep.flightStatus.flightNumber && depInfo.departure.airport.code == f.departure.airport.code)
  const flightWithLegs = useSelector(state => state.entities.flights.flightWithLegs)
  let depOffset = flightWithLegs ? flightWithLegs.legs[0].departure.airport.utcOffset.minutes : false
  let arrOffset = flightWithLegs ? flightWithLegs.legs[0].arrival.airport.utcOffset.minutes : false
  let depDate = depInfo.departure.estimatedTime
  let arrDate = depInfo.arrival.estimatedTime
  const [newDep, setNewDep] = React.useState(formatDateForInput(depDate))
  const [newArr, setNewArr] = React.useState(formatDateForInput(arrDate))

  // NOTE // gets flights for the departure date for handleMoveFlight
  useEffect(() => {
    // NOTE // gets flight leg info
    dispatch(loadFlight(flight.key))
  }, [flight]);

  // NOTE // can't move departures, need to move flights
  const handleMoveFlight = async () => {
    let newFlight = _.cloneDeep(flightWithLegs)

    newFlight.legs[0].departure.scheduledTime = formatDateForMoveFlight(newDep)
    newFlight.legs[0].departure.localScheduledTime = formatDateForMoveFlight(newDep, depOffset)
    newFlight.legs[0].arrival.scheduledTime = formatDateForMoveFlight(newArr)
    newFlight.legs[0].arrival.localScheduledTime = formatDateForMoveFlight(newArr, arrOffset)

    dispatch(moveFlight(flight.key, newFlight))
    props.closeModal(false)
    // NOTE // need to wait a second for amelia to update the flight and departure
    setTimeout(function() {dispatch(loadDepartures(props.depDate))}, 1000)
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      <Paper className={classes.paper}>
        <Grid container item justify="center" xs={12} style={{fontSize: '60px', width: '100%', height: '20%', borderBottom: '2px solid rgba(201, 195, 195, 1)', backgroundColor: 'rgb(63, 81, 181, 1)'}}>
          <h5 style={{margin: '0px', paddingTop: '12px'}}>Move Flight</h5>
        </Grid>
        <Grid container justify="center">
          <Grid container item justify="center" xs={4}>
            <h5 style={{margin: '4px', paddingTop: '12px', borderBottom: '2px solid gray'}}>Flight {dep.flightStatus.flightNumber}</h5>
          </Grid>
        </Grid>
        <Grid container justify="center" style={{marginTop: '10px'}}>
          <form className={classes.container} noValidate>
            <Grid container item justify="center" md={6} xs={12}>
              <TextField
                style={{marginRight: '5px'}}
                id="new-departure"
                label="New Departure Date"
                type="datetime-local"
                defaultValue={formatDateForInput(depDate)}
                onChange={(e) => {setNewDep(e.target.value)}}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid container item justify="center" md={6} xs={12}>
              <TextField
                style={{marginRight: '5px'}}
                id="new-arrival"
                label="New Arrival Date"
                type="datetime-local"
                defaultValue={formatDateForInput(arrDate)}
                onChange={(e) => {setNewArr(e.target.value)}}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </form>
        </Grid>
        <Grid container item justify="center" xs={12} style={{marginBottom: '8px', marginTop: '8px'}}>
            <Button variant="contained" size="small" style={{backgroundColor: '#03fc66', marginRight: '10px'}} onClick={() => {handleMoveFlight()}}>Save</Button>
            <Button variant="contained" size="small" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
        </Grid>
      </Paper>
    </Grid>
  )
}